import { makeStyles } from "@material-ui/core/styles";
import BannerImage from "../../../assets/images/img-otros-plan.png";

const styles = makeStyles(theme => ({
  guideMainContainer: {
    display: "flex",
    justifyContent: "center",
    padding: "160px 16% 85px 16%",
    [theme.breakpoints.down("md")]: {
      padding: "40px"
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0",
      marginTop: "60px"
    }
  },
  guideContent: {
    minWidth: "100%",
    backgroundColor: "#f6f6f6",
    paddingRight: "25px",
    paddingBottom: "20px",
    [theme.breakpoints.down("sm")]: {
      minWidth: "550px"
    },
    [theme.breakpoints.down("xs")]: {
      minWidth: "90%",
      marginLeft: "10px",
      marginRight: "10px"
    }
  },
  rowContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
    marginTop: "20px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "baseline"
    }
  },
  titleContainer: {
    display: "flex",
    alignItems: "center"
  },
  subtitle: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#0073cf",
    paddingLeft: "30px",
    [theme.breakpoints.down("sm")]: {
      width: "300px"
    }
  },
  titleSection: {
    fontSize: "24px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    fontFamily: "Trebuchet",
    lineHeight: "1.1",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: "440px",
    marginBlockStart: "0em",
    marginBlockEnd: "0em"
  },

  lineTitle: {
    borderLeft: "10px solid #0073cf",
    height: "50px",
    marginRight: "20px"
  },
  lineDivisor: {
    border: "1px solid #ececec",
    marginTop: "20px",
    marginBottom: "20px",
    marginLeft: "20px"
  },
  buttonContainer: {
    width: "200px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #00b9e4",
    borderRadius: "5px",
    textDecoration: "none",
    color: "#0073cf",
    [theme.breakpoints.down("xs")]: {
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: "15px"
    }
  }
}));

export default styles;
